import React, { useState } from "react";
import { api } from "@/lib/api";
import TopBar from "@/components/TopBar";
import { toast } from "sonner";
import { Key } from "@phosphor-icons/react";
import { useAuth } from "@/context/AuthContext";
import Footer from "@/components/Footer";

export default function Settings() {
  const { user } = useAuth();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next.length < 6) { toast.error("New password must be at least 6 characters"); return; }
    if (next !== confirm) { toast.error("New passwords do not match"); return; }
    setLoading(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Password updated");
      setCurrent(""); setNext(""); setConfirm("");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Update failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#050505] text-white">
      <TopBar />
      <div className="max-w-md mx-auto px-6 py-10">
        <div className="micro-label">/ account settings</div>
        <h1 className="font-heading text-3xl mt-1 mb-2">Account</h1>
        <p className="text-xs text-[#8a8a8e] font-mono-data mb-8">SIGNED IN AS · {user?.email}</p>

        <form onSubmit={submit} className="panel p-5" data-testid="change-password-form">
          <div className="flex items-center gap-2 mb-4">
            <Key size={14} className="text-[#f2ce72]"/>
            <span className="micro-label">/ change password</span>
          </div>

          <label className="micro-label">Current Password</label>
          <input
            type="password" required
            value={current} onChange={e=>setCurrent(e.target.value)}
            data-testid="current-password"
            className="w-full mt-1 mb-4 px-3 py-2 bg-[#0a0a0a] border border-[#222] focus:border-[#444] outline-none font-mono-data text-sm"
          />

          <label className="micro-label">New Password</label>
          <input
            type="password" required minLength={6}
            value={next} onChange={e=>setNext(e.target.value)}
            data-testid="new-password"
            className="w-full mt-1 mb-4 px-3 py-2 bg-[#0a0a0a] border border-[#222] focus:border-[#444] outline-none font-mono-data text-sm"
          />

          <label className="micro-label">Confirm New Password</label>
          <input
            type="password" required minLength={6}
            value={confirm} onChange={e=>setConfirm(e.target.value)}
            data-testid="confirm-password"
            className="w-full mt-1 mb-6 px-3 py-2 bg-[#0a0a0a] border border-[#222] focus:border-[#444] outline-none font-mono-data text-sm"
          />

          <button
            type="submit"
            disabled={loading}
            data-testid="change-password-submit"
            className="w-full py-3 bg-white text-black hover:bg-[#00e676] transition-colors text-sm font-medium tracking-widest uppercase disabled:opacity-50"
          >
            {loading ? "..." : "Update Password"}
          </button>
        </form>
      </div>
      <Footer />
    </div>
  );
}
